<template>
  <!-- 因为decorator必须是form-item的直接子集，所以只能放到这里 -->
  <a-form-item :required="required" :label="label">
    <a-input
      :size="size"
      :placeholder="placeholder"
      v-decorator="[
        phoneKey,
        {
          initialValue: phone,
          rules: [
            {
              validator: validateHandler
            }
          ],
          validateTrigger: 'blur'
        }
      ]"
      @blur="onPhoneChange"
    >
      <a-select slot="addonBefore" :options="areaCodeOptions" option-label-prop="title" v-decorator="[
        areaCodeKey,
        {
          initialValue: areaCode,
          rules: []
        }
      ]"
      @change="onAreaCodeChange"
      ></a-select>
      <a-icon v-if="prefix" slot="prefix" :type="prefix" />
    </a-input>
  </a-form-item>
</template>

<script>
import { get } from 'lodash'
import areaCodeOptions from '@/utils/areacode'

export default {
  name: 'mobile-input',
  props: {
    label: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'large'
    },
    placeholder: {
      type: String,
      default: '请输入手机号'
    },
    phoneKey: {
      type: String,
      default: 'phone'
    },
    areaCodeKey: {
      type: String,
      default: 'areaCode'
    },
    prefix: {
      type: String,
      default: ''
    },
    form: Object,
    validateHandler: {
      type: Function,
      required: true
    },
    isInit: {
      type: Boolean,
      default: true
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      phone: '',
      areaCode: '86',
      areaCodeOptions
    }
  },
  mounted () {
    if (this.isInit) {
      const userInfo = this.$ls.get('USER_CENTER_INFO')

      if (userInfo) {
        const areaCode = this.areaCode = userInfo.areaCode || '86'
        const phone = this.phone = userInfo.phone || ''
        this.$emit('change', {
          areaCode,
          phone
        })
      }
    }
  },
  methods: {
    onAreaCodeChange (value) {
      this.areaCode = value
      this.onChange()
    },
    onPhoneChange (e) {
      this.onChange()
    },
    onChange () {
      const { areaCode, phoneKey } = this

      // setTimeout放到队列，保证 areaCode 设置完成才去校验
      setTimeout(() => {
        this.form.validateFields([phoneKey], (errors, values) => {
          if (!errors) {
            const phone = this.phone = get(values, phoneKey)
            this.$emit('change', {
              areaCode,
              phone
            })
          } else {
            this.phone = ''
            this.$emit('change', {
              areaCode,
              phone: ''
            })
          }
        })
      }, 0)
    }
  }
}
</script>
